function shouldUseExternalSelectedValueLayout(selectionMode, selectedValueLayout) {
  if (selectedValueLayout === 'external') {
    return true;
  }
  if (selectedValueLayout === 'inline') {
    return false;
  }
  return selectionMode === 'multiple' || selectionMode === 'checkbox';
}
function createChangeEvent(event, props, value) {
  var _a, _b;
  return {
    originalEvent: event,
    value,
    stopPropagation: () => {
      event === null || event === void 0 ? void 0 : event.stopPropagation();
    },
    preventDefault: () => {
      event === null || event === void 0 ? void 0 : event.preventDefault();
    },
    target: {
      name: (_a = props.name) !== null && _a !== void 0 ? _a : '',
      id: (_b = props.id) !== null && _b !== void 0 ? _b : '',
      value
    }
  };
}

export { createChangeEvent, shouldUseExternalSelectedValueLayout };
